<template>
  <app-page-subsection
    id="nextSessions"
    class="@container"
    :title="$t('teacher.page.next_sessions_title')"
  >
    <div class="grid gap-8 @xl:grid-cols-2 @3xl:grid-cols-3">
      <course-list-item
        v-for="course in list"
        :key="course.id"
        :course="course"
      />
    </div>
  </app-page-subsection>
</template>

<script lang="ts" setup>
import type { CourseListView } from "~/business-areas/course/composables/course-list.hook";

defineProps<{
  list: CourseListView[];
}>();
</script>
